import type { Field, FieldInputConfigProtocol, FieldType, TypeInstanceMap } from '@lighthouse/core'
import { DataSourceType } from '@lighthouse/core'

export const DATASOURCE_CELL_DATA_KEY = 'data-key'

export const DATASOURCE_FIELD_DATA_KEY = 'data-field'

export const DATASOURCE_CELL_FIELD_DATA_KEY = 'data-cell-field'

export const VIEW_CELL_DATA_KEY = 'data-key' // 'data-view-key'

export const VIEW_FIELD_DATA_KEY = 'data-field' // 'data-view-field'

export const VIEW_CELL_FIELD_DATA_KEY = 'data-cell-field' // 'data-view-cell-field'

export const SYSTEM_USER_FIELD = new Set<string>([
    'USERNAME',
    'AVATAR',
    'MOBILE',
    'ROLE',
    'EMAIL',
    'DEPARTMENT',
    'STATUS',
    'ROLE_NAME',
    'DEPARTMENT_NAME',
    'PARENT_DEPARTMENT',
    'MANAGER_USER',
    // 'WECHAT_UNION_ID',
    // 'WECHAT_PC_OPENID',
    'WECHAT_OPENID',
    'WECHAT_ID',
    'WECHAT_MINI_PROGRAM_OPENID'
])

export const SYSTEM_ID = new Set<string>(['ID'])
export const SYSTEM_FIELD = new Set<string>([...SYSTEM_USER_FIELD, 'createdTime', 'updatedTime', 'updatedBy', 'createdBy', 'ID'])

export const NO_EDIT_SYSTEM_USER_FIELD = new Set<string>(['WECHAT_OPENID', 'WECHAT_ID', 'WECHAT_MINI_PROGRAM_OPENID'])

export const NO_EDIT_SYSTEM_FIELD = new Set<string>([
    ...NO_EDIT_SYSTEM_USER_FIELD,
    'createdTime',
    'updatedTime',
    'updatedBy',
    'createdBy',
    'ID'
])

// 给数据表映射字段使用
export const NO_EDIT_SYSTEM_FIELD_OMIT_ID = new Set<string>([
    ...NO_EDIT_SYSTEM_USER_FIELD,
    'createdTime',
    'updatedTime',
    'updatedBy',
    'createdBy'
])

/** 不能作为文本展示的inner type类型 */
export const INNER_TYPE_CANNOT_DISPLAY_AS_TEXT = new Set<TypeInstanceMap>(['RICH_TEXT', 'NULL'])

/**
 * table not editor cell
 */
export const createFieldNeedFetchData = new Set<FieldType>(['formula'])

export const noRealFieldTypes = new Set<FieldType>(['formula', 'aggregation'])

export const updateFieldNeedFetchData = new Set<FieldType>(['select', 'formula'])

export const noFormulaField = new Set<FieldType>(['notes', 'file', 'video'])

export const resourceField = new Set<FieldType>(['file', 'video'])

export const notEditableFieldTypes = new Set<Partial<FieldType>>(['id', 'formula', 'aggregation'])

export const editableInCellFieldTypes = new Set<Partial<FieldType>>(['checkbox'])

// 表格中强调文本
export const emphasizeFieldTypes = new Set<FieldType>(['text', 'email', 'phoneNumber', 'url', 'number'])

export const notImportableFieldTypes = new Set<Partial<FieldType>>([
    'formula',
    'notes'
    /* 'file', */
])

export const notMatchImportableFieldTypes = new Set<Partial<FieldType>>([
    'formula',
    /* 'file', */
    'file',
    'video',
    'notes',
    'date'
])

export const WYSIWYGFieldTypes = new Set<Partial<FieldType>>(['notes', 'url', 'phoneNumber', 'email', 'text', 'number'])

export const inputFieldTypes = new Set<Partial<FieldType>>(['id', 'text', 'phoneNumber', 'url', 'email', 'formula', 'number'])

export const dataSourceNotSettingFieldTypes = new Set<FieldType>([])

export const notDataSettingInnerTypes = new Set<TypeInstanceMap>(['NULL', 'RICH_TEXT', 'RUNTIME'])

// export const viewSettingFieldTypes = new Set<FieldType>(['text', 'date', 'number'])

// export const extraFieldTypes = new Set<FieldType>(['notes', 'formula'])

export const systemPersonFieldId = new Set<string>(['createdBy', 'updatedBy'])
// 特殊系统字段 UI 处理
export const signFieldId = new Set<string>(['ID', 'createdBy', 'updatedBy', 'createdTime', 'updatedTime', 'recordId'])

export const dateFieldTypes = new Set<FieldType>(['date'])

export const numberFieldTypes = new Set<FieldType>(['number'])

export const personFieldTypes = new Set<FieldType>(['person'])

export const addresseeFieldType = new Set<FieldType>(['person', 'role', 'department'])

export const boolFieldTypes = new Set<FieldType>(['checkbox'])

export const extraFieldDataSource = new Set<DataSourceType>([
    DataSourceType.systemDataSource,
    DataSourceType.joinDataSource,
    DataSourceType.dataSource
])

export const disableAppendDataSourceType = new Set<DataSourceType>([DataSourceType.aggregateDataSource])

export const disableJoinDataSourceType = new Set<DataSourceType>([DataSourceType.joinDataSource, DataSourceType.aggregateDataSource])

export const signFieldIconColor = 'var(--color-blue-500)'

export const simpleFieldTypes = new Set<Partial<FieldType>>([
    'id',
    'text',
    'number',
    'select',
    'email',
    'phoneNumber',
    'url',
    'date',
    'notes'
])

export const joinDataSourceFieldType = new Set<FieldType>(['formula'])

export const datasourceFieldTypes: FieldType[] = [
    'id',
    'text',
    'number',
    'file',
    'video',
    'person',
    'select',
    'email',
    'phoneNumber',
    'url',
    'date',
    'notes',
    'formula',
    'checkbox',
    'role',
    'department',
    'singleSelect',
    'parentDepartment'
]

export const dataSourceInnerTypes: TypeInstanceMap[] = ['TEXT', 'NUMBER', 'DATE', 'BOOL', 'ARRAY', 'NULL']

export const FieldTypeColorMap: Record<FieldType, string | undefined> = {
    id: '',
    text: '',
    number: '',
    email: '',
    phoneNumber: '',
    url: '',
    select: '',
    date: '',
    file: '',
    video: '',
    notes: signFieldIconColor,
    person: '',
    formula: signFieldIconColor,
    role: '',
    checkbox: '',
    department: '',
    aggregation: signFieldIconColor,
    singleSelect: '',
    parentDepartment: '',
    runtime: ''
}

export const FieldClassMap: Record<FieldType, Set<FieldType>> = {
    id: simpleFieldTypes,
    text: simpleFieldTypes,
    number: numberFieldTypes,
    email: simpleFieldTypes,
    phoneNumber: simpleFieldTypes,
    url: simpleFieldTypes,
    select: new Set<FieldType>([]),
    date: dateFieldTypes,
    file: new Set<FieldType>([]),
    video: new Set<FieldType>([]),
    notes: simpleFieldTypes,
    person: personFieldTypes,
    formula: new Set<FieldType>([]),
    role: new Set<FieldType>([]),
    checkbox: boolFieldTypes,
    department: new Set<FieldType>([]),
    aggregation: new Set<FieldType>([]),
    singleSelect: simpleFieldTypes,
    parentDepartment: simpleFieldTypes,
    runtime: simpleFieldTypes
}
/**
 * table view column min width
 */
export const COL_MIN_WIDTH = 100

/**
 * map field to icon type
 */

export const SystemFieldIconTypeMap: Record<string, string> = {
    USERNAME: 'PropertyText',
    AVATAR: 'BlockFile',
    MOBILE: 'PropertyPhone',
    ROLE: 'SpaceTeam',
    ID: 'PropertyID',
    createdTime: 'PropertyCalendar',
    updatedTime: 'PropertyCalendar',
    updatedBy: 'PropertyEditor',
    createdBy: 'PropertyCreator',
    EMAIL: 'PropertyEmail',
    DEPARTMENT: 'Departments',
    WECHAT_UNION_ID: 'WeChatLogo',
    WECHAT_PC_OPENID: 'WeChatLogo',
    WECHAT_OPENID: 'WeChatLogo',
    WECHAT_ID: 'WeChatLogo',
    STATUS: 'PropertyAccountStatus',
    ROLE_NAME: 'PropertyText',
    DEPARTMENT_NAME: 'PropertyText',
    PARENT_DEPARTMENT: 'Departments',
    MANAGER_USER: 'Wrench',
    WECHAT_MINI_PROGRAM_OPENID: 'MiniProgram'
}

export const FieldIconTypeMap: Record<string, string> = {
    id: 'PropertyID',
    text: 'PropertyText',
    number: 'PropertyNumber',
    email: 'PropertyEmail',
    phoneNumber: 'PropertyPhone',
    url: 'PropertyLink',
    select: 'PropertySingleSelect',
    date: 'PropertyCalendar',
    file: 'BlockFile',
    video: 'BlockVideo',
    person: 'PropertyPerson',
    relation: 'PropertyRelation',
    relationed: 'PropertyRelationed',
    formula: 'PropertyFormula',
    notes: 'PropertyNote',
    createdBy: 'PropertyCreator',
    createdTime: 'PropertyCalendar',
    updatedBy: 'PropertyCreator',
    updatedTime: 'PropertyCalendar',
    role: 'SpaceTeam',
    cascade: 'Cascade',
    checkbox: 'PropertyCheckbox',
    department: 'Departments',
    aggregation: '',
    singleSelect: '',
    parentDepartment: 'Departments'
}

export const FieldNameMap: Record<FieldType, string> = {
    id: '自动编号',
    text: '文本',
    number: '数值',
    email: '邮箱',
    phoneNumber: '电话',
    url: '链接',
    select: '选项',
    date: '日期',
    file: '附件',
    video: '视频',
    person: '人员',
    notes: '笔记',
    formula: '计算',
    role: '归属角色',
    checkbox: '复选框',
    department: '部门',
    aggregation: '聚合',
    singleSelect: '单选',
    parentDepartment: '上级部门',
    runtime: ''
}

export const themeCellTypes: Field['type'][] = ['text', 'email', 'phoneNumber', 'url', 'number', 'notes']

export const MultipleFieldTypes: Field['type'][] = ['file']

export const FieldInputNameMap: Record<FieldInputConfigProtocol['inputType'], string> = {
    text: '文本输入',
    number: '数值输入',
    email: '邮箱输入',
    phoneNumber: '电话输入',
    url: '链接输入',
    // select: '选项',
    date: '日期选择',
    file: '上传附件',
    notes: '笔记输入',
    relativeSelect: '选项选择',
    person: '人员选择',
    checkbox: '复选框',
    slider: '滑动输入',
    cascade: '级联选择',
    calendar: '日历输入'
}

export const DataSourceNameMap: Record<DataSourceType, string> = {
    2: '用户数据源',
    5: '连接表',
    6: '数据源',
    7: '聚合数据源'
}

export const FieldInputIconTypeMap: Record<FieldInputConfigProtocol['inputType'], string> = {
    text: 'PropertyText',
    number: 'PropertyNumber',
    email: 'PropertyEmail',
    phoneNumber: 'PropertyPhone',
    url: 'PropertyLink',
    // select: 'PropertySingleSelect',
    date: 'PropertyCalendar',
    file: 'BlockFile',
    notes: 'PropertyNote',
    relativeSelect: 'PropertySingleSelect',
    person: 'PropertyPerson',
    checkbox: 'PropertyCheckbox',
    slider: 'PropertyNumber',
    cascade: 'PropertyCascade',
    calendar: 'PropertyCalendar'
}

export const innerTypeToFieldType: Record<TypeInstanceMap, FieldType | undefined> = {
    NUMBER: 'number',
    TEXT: 'text',
    DATE: 'date',
    BOOL: 'checkbox',
    RICH_TEXT: 'notes',
    ARRAY: undefined,
    NULL: undefined,
    RUNTIME: undefined
}

export const FieldNameMapByInnerType: Record<TypeInstanceMap, string> = {
    NUMBER: '数值',
    TEXT: '文本',
    DATE: '日期',
    BOOL: '复选框',
    ARRAY: '数组',
    RICH_TEXT: '富文本',
    NULL: 'NULL',
    RUNTIME: 'RUNTIME'
}

export const InnerTypeMapByFieldType: Record<FieldType, TypeInstanceMap> = {
    id: 'TEXT',
    text: 'TEXT',
    number: 'NUMBER',
    email: 'TEXT',
    phoneNumber: 'TEXT',
    url: 'TEXT',
    select: 'ARRAY',
    date: 'DATE',
    file: 'ARRAY',
    video: 'ARRAY',
    person: 'ARRAY',
    notes: 'RICH_TEXT',
    formula: 'NULL',
    role: 'ARRAY',
    checkbox: 'BOOL',
    department: 'ARRAY',
    aggregation: 'NULL',
    singleSelect: 'TEXT',
    parentDepartment: 'TEXT',
    runtime: 'TEXT'
}
// export const innerTypeToOperatorMap: Record<TypeInstanceMap, FieldType> = {
//     NUMBER: 'number',
//     TEXT: 'text',
//     DATE: 'date',
//     BOOL: 'checkbox',
//     USER: 'person',
//     FILE: 'file',
//     SELECT: 'select',
//     RICH_TEXT: 'notes',
//     NULL: 'file',
//     ARRAY_OF_NUMBER: 'formula',
//     ARRAY_OF_TEXT: 'formula',
//     ARRAY_OF_DATE: 'formula',
//     ARRAY_OF_BOOL: 'formula',
//     ARRAY_OF_USER: 'person',
//     ARRAY_OF_FILE: 'file',
//     ARRAY_OF_SELECT: 'select'
// }

export const innerTypeToFieldTypeMapInCondition: Record<TypeInstanceMap, FieldType | undefined> = {
    NUMBER: 'number',
    TEXT: 'text',
    DATE: 'date',
    BOOL: 'checkbox',
    ARRAY: undefined,
    RICH_TEXT: 'notes',
    NULL: undefined,
    RUNTIME: undefined
}

export const innerTypeToFieldTypeIconMap: Record<TypeInstanceMap, string> = {
    NUMBER: 'PropertyNumber',
    TEXT: 'PropertyText',
    DATE: 'PropertyCalendar',
    BOOL: 'PropertyCheckbox',
    ARRAY: 'PropertyArray',
    NULL: 'PropertyFormulaError',
    RICH_TEXT: 'PropertyNote',
    RUNTIME: 'PropertyFormulaError'
}

// export const innerTypeToFieldTypeNoArrayMap: Record<TypeInstanceMap, FieldType | undefined> = {
//     NUMBER: 'number',
//     TEXT: 'text',
//     DATE: 'date',
//     BOOL: 'text',
//     USER: 'person',
//     FILE: 'file',
//     SELECT: 'select',
//     RICH_TEXT: 'notes',
//     NULL: undefined,
//     ARRAY_OF_NUMBER: undefined,
//     ARRAY_OF_TEXT: undefined,
//     ARRAY_OF_DATE: undefined,
//     ARRAY_OF_BOOL: undefined,
//     ARRAY_OF_USER: 'person',
//     ARRAY_OF_FILE: undefined,
//     ARRAY_OF_SELECT: 'select'
// }

export const placeholderFromFieldType: Record<FieldType, string> = {
    text: '请输入',
    url: '请输入',
    email: '请输入',
    phoneNumber: '请输入',
    number: '请输入',
    date: '请选择',
    file: '请选择',
    video: '请选择',
    notes: '请输入',
    person: '请选择',
    id: '请输入',
    select: '请选择',
    formula: '请选择',
    role: '请选择',
    checkbox: '请选择',
    department: '请选择',
    aggregation: '请选择',
    singleSelect: '请选择',
    parentDepartment: '请选择',
    runtime: '请输入'
}

export const placeholderFromInnerType: Record<TypeInstanceMap, string> = {
    TEXT: '请输入',
    NUMBER: '请输入',
    ARRAY: '请选择',
    BOOL: '请选择',
    DATE: '请选择',
    NULL: '',
    RICH_TEXT: '请输入',
    RUNTIME: '请输入'
}

export const USER_DATASOURCE = 'USER_DATASOURCE'

export const ROLE_DATASOURCE = 'ROLE_DATASOURCE'

export const DEPARTMENT_DATASOURCE = 'DEPARTMENT_DATASOURCE'

export const USER_CODE = 'USER_CODE'

export const editableUserFieldId = new Set<string>(['USERNAME', 'AVATAR', 'DEPARTMENT', 'ROLE'])

export const FieldInnerTypeOfDataTypeNameMap: Record<TypeInstanceMap, string> = {
    NUMBER: '数值',
    TEXT: '文本',
    DATE: '日期',
    BOOL: '布尔',
    ARRAY: '数组',
    NULL: '错误',
    RICH_TEXT: '富文本',
    RUNTIME: '运行时'
}

export const FieldTypeOfDataTypeNameMap: Record<FieldType, string> = {
    id: '文本',
    text: '文本',
    number: '数值',
    email: '文本',
    phoneNumber: '文本',
    url: '文本',
    select: '数组',
    date: '日期',
    file: '数组',
    video: '数组',
    person: '数组',
    notes: '富文本',
    formula: '动态',
    aggregation: '动态',
    role: '数组',
    checkbox: '布尔',
    department: '数组',
    singleSelect: '数组',
    parentDepartment: '数组',
    runtime: '文本'
}
